import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ZahtjeviZaSirovineService {
  constructor(private _http: HttpClient) {}

  dohvatiZahtjeve(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_zahtjev_zaglavlje', a)
      .pipe(map((res: any) => res));
  }

  dohvatiStavke(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_zahtjev_stavke', a)
      .pipe(map((res: any) => res));
  }

  urediStavku(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'uredivanje_stavkizahtjev_skladistar', a)
      .pipe(map((res: any) => res));
  }

  obrisiStavku(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_zahtjevpovrat_stavku', a)
      .pipe(map((res: any) => res));
  }

  kreirajIzdatnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'kreiranje_izdatnice', a)
      .pipe(map((res: any) => res));
  }

  obrisiZahtjevPovrat(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_zahtjev_povrat', a)
      .pipe(map((res: any) => res));
  }
}
